import isSafari from '@academica-box/utils/scripts/isSafari'

export default defineNuxtPlugin(() => {
  isSafari()
})
